// import { useState } from "react";
// import { WelcomeSection } from "./dashboard/WelcomeSection";
// import { TodaysPracticeCard } from "./dashboard/TodaysPracticeCard";
// import { RecentTrainingSetsCard } from "./dashboard/RecentTrainingSetsCard";
// import { DistanceStatsCard } from "./dashboard/DistanceStatsCard";
// import { WeeklyPracticeChart } from "./dashboard/WeeklyPracticeChart";

// export function DashboardContent() {
//   const login_user_name = localStorage.getItem("current_user_name");
//   // main controls
//   const [timeframe, setTimeframe] = useState("week"); // "week" | "month"
//   const [poolType, setPoolType] = useState("SCY"); // "SCY" | "SCM" | "LCM"

//   const isMonth = timeframe === "month";
//   const weeklyYardage = Number(localStorage.getItem("weekly_yardage") || 0);
//   const monthlyYardage = Number(localStorage.getItem("monthly_yardage") || 0);
//   const lastWeeklyYardage = Number(localStorage.getItem("last_weekly_yardage") || 0);
//   const lastMonthlyYardage = Number(localStorage.getItem("last_monthly_yardage") || 0);

//   const weekChange =
//     lastWeeklyYardage > 0
//       ? (((weeklyYardage - lastWeeklyYardage) / lastWeeklyYardage) * 100).toFixed(1)
//       : "—";

//   const monthChange =
//     lastMonthlyYardage > 0
//       ? (((monthlyYardage - lastMonthlyYardage) / lastMonthlyYardage) * 100).toFixed(1)
//       : "—";

//   const stats = {
//     week: {
//       current: { label: "This Week", change: `${parseFloat(weekChange) > 0 ? "+" : ""}${weekChange}%` },
//       previous: { label: "Last Week", distance: lastWeeklyYardage }, // number
//       distance: weeklyYardage, // number
//     },
//     month: {
//       current: { label: "This Month", change: `${parseFloat(monthChange) > 0 ? "+" : ""}${monthChange}%` },
//       previous: { label: "Last Month", distance: lastMonthlyYardage },
//       distance: monthlyYardage,
//     },
//   };

//   const data = isMonth ? stats.month : stats.week;
//   const todayPractice = JSON.parse(localStorage.getItem("today_practice") || "null");

//   const formatNumber = (n: number | string) =>
//   typeof n === "number" ? n.toLocaleString() : n;

// const [weekOffset, setWeekOffset] = useState<number>(0); // 0 = current week, -1 = previous, +1 = next

// const getWeekLabel = (offset: number): string => {
//   const today = new Date();
//   const currentMonday = new Date(today);
//   currentMonday.setDate(today.getDate() - today.getDay() + 1);

//   const targetMonday = new Date(currentMonday);
//   targetMonday.setDate(currentMonday.getDate() + offset * 7);
//   const targetSunday = new Date(targetMonday);
//   targetSunday.setDate(targetMonday.getDate() + 6);

//   const options: Intl.DateTimeFormatOptions = { month: "short", day: "numeric" };
//   return `${targetMonday.toLocaleDateString(undefined, options)} - ${targetSunday.toLocaleDateString(
//     undefined,
//     options
//   )}`;
// };

// const weekLabel = getWeekLabel(weekOffset);

// const getWeekDays = (offset: number) => {
//   const today = new Date();
//   const monday = new Date(today);
//   monday.setDate(today.getDate() - today.getDay() + 1 + offset * 7);

//   const days = [];
//   for (let i = 0; i < 7; i++) {
//     const d = new Date(monday);
//     d.setDate(monday.getDate() + i);
//     days.push({
//       date: d.toLocaleDateString(undefined, {
//         month: "2-digit",
//         day: "2-digit",
//         year : "2-digit"
//       } as Intl.DateTimeFormatOptions),
//       label: d.toLocaleDateString(undefined, {
//         weekday: "short",
//       } as Intl.DateTimeFormatOptions),
//     });
//   }
//   return days;
// };

// const weekDays = getWeekDays(weekOffset);
// const recentLaps = JSON.parse(localStorage.getItem("recent_laps") || "[]");


// const recentWorkouts: Array<{
//   name: string;
//   date: string;
//   duration: string;
//   distance: string;
//   intensity: "High" | "Medium" | "Low";
// }> = Array.isArray(recentLaps)
//   ? recentLaps.slice(0, 5).map((lap: any) => ({
//       name: lap.stroke ? `${lap.stroke} Set` : "Swim Set",
//       date: lap.createdAt
//         ? new Date(lap.createdAt).toLocaleDateString("en-US", {
//             month: "short",
//             day: "numeric",
//           })
//         : "—",
//       duration: lap.rep ? `${lap.rep} reps` : "",
//       distance: lap.distance ? `${lap.distance}m` : "",
//       intensity: (
//         lap.distance >= 100 && lap.rep >= 4 ? "High"
//         : lap.distance >= 50 ? "Medium"
//         : "Low"
//       ) as "High" | "Medium" | "Low",
//     }))
//   : [];

// const defaultWorkouts = [
//   {
//     name: "Sprint Intervals",
//     date: "Today",
//     duration: "45 min",
//     distance: "2,400m",
//     intensity: "High",
//   },
//   {
//     name: "Endurance Base",
//     date: "Yesterday",
//     duration: "60 min",
//     distance: "3,200m",
//     intensity: "Medium",
//   },
//   {
//     name: "Technique Focus",
//     date: "2 days ago",
//     duration: "40 min",
//     distance: "1,800m",
//     intensity: "Low",
//   },
// ];

// const displayWorkouts: Array<{
//   name: string;
//   date: string;
//   duration: string;
//   distance: string;
//   intensity: "High" | "Medium" | "Low";
// }> = (recentWorkouts.length > 0 ? recentWorkouts : defaultWorkouts) as Array<{
//   name: string;
//   date: string;
//   duration: string;
//   distance: string;
//   intensity: "High" | "Medium" | "Low";
// }>;

//   const handleStartPractice = () => {
//     // Handle start practice action - navigate to practice page
//     // This can be implemented based on routing needs
//   };

//   return (
//     <div className="space-y-6">
//       <WelcomeSection 
//         userName={login_user_name || "User"} 
//         onStartPractice={handleStartPractice}
//       />

//       <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
//         <div className="space-y-6">
//           <TodaysPracticeCard 
//             practice={todayPractice}
//             onStartPractice={handleStartPractice}
//             formatNumber={formatNumber}
//           />

//           <RecentTrainingSetsCard workouts={displayWorkouts} />
//         </div>

//         <div className="space-y-6">
//           <DistanceStatsCard
//             currentDistance={data.distance}
//             currentLabel={data.current.label}
//             previousDistance={data.previous.distance}
//             previousLabel={data.previous.label}
//             poolType={poolType as "SCY" | "SCM" | "LCM"}
//             timeframe={timeframe as "week" | "month"}
//             onPoolTypeChange={(type) => setPoolType(type)}
//             onTimeframeChange={(tf) => setTimeframe(tf)}
//             formatNumber={formatNumber}
//           />

//           <WeeklyPracticeChart
//             weekLabel={weekLabel}
//             weekDays={weekDays}
//             onPreviousWeek={() => setWeekOffset((prev) => prev - 1)}
//             onNextWeek={() => setWeekOffset((prev) => prev + 1)}
//             formatNumber={formatNumber}
//           />
//         </div>
//       </div>
//     </div>
//   );
// }


import { useEffect, useState } from "react";
import { WelcomeSection } from "./dashboard/WelcomeSection";
import { TodaysPracticeCard } from "./dashboard/TodaysPracticeCard";
import { RecentTrainingSetsCard } from "./dashboard/RecentTrainingSetsCard";
import { DistanceStatsCard } from "./dashboard/DistanceStatsCard";
import { WeeklyPracticeChart } from "./dashboard/WeeklyPracticeChart";
import { UserRepository } from "@/infrastructure/repositories/UserRepository";
import type { Workout } from "./dashboard/RecentTrainingSetsCard";
import { secureStorage } from "@/utils/secureStorage";

export function DashboardContent() {
  const login_user_name =
  secureStorage.get<string>("current_user_name") ?? "";

  const userRepo = new UserRepository();

  // ---------------- STATE ----------------
  const [timeframe, setTimeframe] = useState<"week" | "month">("week");
  const [poolType, setPoolType] = useState<"SCY" | "SCM" | "LCM">("SCY");
  const [weekOffset, setWeekOffset] = useState<number>(0);

  const [weeklyApiData, setWeeklyApiData] = useState<any>(null) ;
  const [loading, setLoading] = useState(false);

  console.log(loading)
  // ---------------- HELPERS ----------------
  const getWeekStartDate = (offset: number) => {
    const today = new Date();
    const monday = new Date(today);
    monday.setDate(today.getDate() - today.getDay() + 1 + offset * 7);
    return monday.toISOString().slice(0, 10);
  };

  const fetchWeeklySummary = async (offset: number) => {
    try {
      setLoading(true);

      const userId = Number(
        localStorage.getItem("current_user_swimmer_id")
      );

      const weekStartDate = getWeekStartDate(offset);

      const res = await userRepo.getWeeklyPracticeSummary(
        weekStartDate,
        userId
      );

      setWeeklyApiData(res.data);
    } catch (err) {
      console.error("Weekly summary fetch failed", err);
    } finally {
      setLoading(false);
    }
  };

  // ---------------- EFFECTS ----------------
  useEffect(() => {
    fetchWeeklySummary(weekOffset);
  }, [weekOffset]);

  useEffect(() => {
    if (!weeklyApiData?.summary?.weekly?.last_week) return;

    setPoolType((prev) => {
      const lw = weeklyApiData.summary.weekly.last_week;

      if (lw[prev] > 0) return prev;
      if (lw.SCY > 0) return "SCY";
      if (lw.SCM > 0) return "SCM";
      if (lw.LCM > 0) return "LCM";

      return prev;
    });
  }, [weeklyApiData]);

  // ---------------- DATA MAPPING ----------------
  const summary = weeklyApiData?.summary;

  const activeSummary =
    timeframe === "week"
      ? summary?.weekly
      : summary?.monthly;

  const currentDistance =
    timeframe === "week"
      ? activeSummary?.this_week?.[poolType] ?? 0
      : activeSummary?.this_month?.[poolType] ?? 0;

  const previousDistance =
    timeframe === "week"
      ? activeSummary?.last_week?.[poolType] ?? 0
      : activeSummary?.last_month?.[poolType] ?? 0;


  // ---------------- UI HELPERS ----------------
  const formatNumber = (n: number | string) =>
    typeof n === "number" ? n.toLocaleString() : n;

  const getWeekLabel = (offset: number): string => {
    const today = new Date();
    const monday = new Date(today);
    monday.setDate(today.getDate() - today.getDay() + 1 + offset * 7);

    const sunday = new Date(monday);
    sunday.setDate(monday.getDate() + 6);

    const options: Intl.DateTimeFormatOptions = {
      month: "short",
      day: "numeric",
    };

    return `${monday.toLocaleDateString(undefined, options)} - ${sunday.toLocaleDateString(
      undefined,
      options
    )}`;
  };

  const weekLabel = getWeekLabel(weekOffset);

  const getWeekDays = (offset: number) => {
    const today = new Date();
    const monday = new Date(today);
    monday.setDate(today.getDate() - today.getDay() + 1 + offset * 7);

    return Array.from({ length: 7 }).map((_, i) => {
      const d = new Date(monday);
      d.setDate(monday.getDate() + i);

      return {
        date: d.toLocaleDateString(undefined, {
          month: "2-digit",
          day: "2-digit",
          year: "2-digit",
        }),
        label: d.toLocaleDateString(undefined, { weekday: "short" }),
      };
    });
  };

  const weekDays = getWeekDays(weekOffset);

  // ---------------- OTHER DATA ----------------
  const todayPractice = JSON.parse(
    localStorage.getItem("today_practice") || "null"
  );

  const recentLaps = JSON.parse(
    localStorage.getItem("recent_laps") || "[]"
  );


const dailyDistances: Record<string, number[]> =
  weeklyApiData?.distance_by_day
    ? Object.fromEntries(
        Object.entries(weeklyApiData.distance_by_day).map(
          ([day, value]: any) => [
            day,
            (value.distances || []).map(Number),
          ]
        )
      )
    : {};

 const recentWorkouts: Workout[] =
  Array.isArray(recentLaps) && recentLaps.length > 0
    ? recentLaps.slice(0, 5).map((lap: any): Workout => ({
        name: lap.stroke ? `${lap.stroke} Set` : "Swim Set",
        date: lap.createdAt
          ? new Date(lap.createdAt).toLocaleDateString("en-US", {
              month: "short",
              day: "numeric",
            })
          : "—",
        duration: lap.rep ? `${lap.rep} reps` : "",
        distance: lap.distance ? `${lap.distance}m` : "",
        intensity:
          lap.distance >= 100 && lap.rep >= 4
            ? "High"
            : lap.distance >= 50
            ? "Medium"
            : "Low",
      }))
    : [];

const defaultWorkouts: Workout[] = [
  {
    name: "Sprint Intervals",
    date: "Today",
    duration: "45 min",
    distance: "2,400m",
    intensity: "High",
  },
  {
    name: "Endurance Base",
    date: "Yesterday",
    duration: "60 min",
    distance: "3,200m",
    intensity: "Medium",
  },
  {
    name: "Technique Focus",
    date: "2 days ago",
    duration: "40 min",
    distance: "1,800m",
    intensity: "Low",
  },
];

const displayWorkouts: Workout[] =
  recentWorkouts.length > 0 ? recentWorkouts : defaultWorkouts;


  // ---------------- RENDER ----------------
  return (
    <div className="space-y-6">
      <WelcomeSection
        userName={login_user_name || "User"}
        onStartPractice={() => {}}
      />

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="space-y-6">
          <TodaysPracticeCard
            practice={todayPractice}
            onStartPractice={() => {}}
            formatNumber={formatNumber}
          />

          <RecentTrainingSetsCard workouts={displayWorkouts} />
        </div>

        <div className="space-y-6">
          <DistanceStatsCard
            currentDistance={currentDistance}
            currentLabel={timeframe === "week" ? "This Week" : "This Month"}
            previousDistance={previousDistance}
            previousLabel={timeframe === "week" ? "Last Week" : "Last Month"}
            poolType={poolType}
            timeframe={timeframe}
            onPoolTypeChange={setPoolType}
            onTimeframeChange={setTimeframe}
          />

          <WeeklyPracticeChart
            weekLabel={weekLabel}
            weekDays={weekDays}
            dailyDistances={dailyDistances}
            onPreviousWeek={() => setWeekOffset((p) => p - 1)}
            onNextWeek={() => setWeekOffset((p) => p + 1)}
            formatNumber={formatNumber}
          />

        </div>
      </div>
    </div>
  );
}

